import React, { useEffect, useState } from "react";
import { useHistory, useParams, Link } from "react-router-dom";
import Header from "../components/common/Header";
import SideBar from "../components/common/SideBar";
import AuditTrail from "../components/StudentAdministration/Students/AuditTrail";
import { GetStudentDetailsCancelToken } from "../services/StudentsSettingServices";
import axios from "axios";
import BrandTemplates from "../components/website/BrandTemplates";
import WebsiteList from "../components/website/WebsiteList";
import PermissionsGate from "../utils/permissionGate";
import EventAuditTrail from "../components/StudentAdministration/Students/EventAuditTrail";
import { getWebsiteAuditTrailList, getWebsiteAuditTrailListFilters } from "../services/WebsiteListServer";
// This will be shown in merge-all branch

function WebsiteManagement() {
    const history = useHistory();
    const { type, id, tab, subType, subId } = useParams();


    const [loading, setLoading] = useState(false);
    const [websiteDetail, setWebsiteDetail] = useState([]);

    useEffect(() => {
        const cancelTokenSources = [];

        const getData = async () => {
            setLoading(true);
            cancelTokenSources.forEach(source => {
                source.cancel('New request made');
            });

            const source = axios.CancelToken.source();
            cancelTokenSources.push(source);

            try {
                setWebsiteDetail({ first_name: "", last_name: "" });
                const res = await GetStudentDetailsCancelToken(id, source.token);
                if (res.status == 200) {
                    setWebsiteDetail(res.data.data_list);
                }
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error(error);
                }
            } finally {
                setLoading(false);
            }
        }

        if (type == "open") {
            getData();
        }

        return () => {
            cancelTokenSources.forEach(source => {
                source.cancel('Component unmounted');
            });
        };
    }, [type]);

    return (
        <>
            <Header />
            <div className="content-wrapper d-flex flex-wrap">
                <SideBar />
                <div className={"sidebar-right " + (tab === "gradebook" ? "bottom-100" : "")}>
                    <div className="sub-menu-content-block">
                        {/* <Tabs /> */}
                        <div className="sub-menu-right-block">
                            <div className="wrap-box-right">
                                <div className="my-tickets-heading-blk flex-direction mb-2">
                                    <div className="d-flex align-items-center ">
                                        <div className="name-w-head d-flex align-items-center ">
                                            <h4 className="text-left-align landing-heading heading_color_dynamic">
                                                {/* Student <span>List</span> */}
                                                {type == "add" ? "Add" : type == "open" ? "Website: " : "Website Mangement: "}
                                                <span>Site Setup</span>
                                            </h4>
                                        </div>
                                        <div className="text-md-right action2-blk">
                                            <div className="ticket-view-btn d-flex align-items-center">
                                                <div className="add-new-ticket-bx">
                                                    <button onClick={() => history.goBack()} title="Back" className="btn btn-white-bordered">
                                                        <i className="fal fa-angle-left"></i>Back
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tabs-wrap">
                                    {(type == "brand_Templates" || type == "table" || type == "auditTrail") && (
                                        <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
                                            <PermissionsGate scopes={['wbssitewebsiteview']} RenderError={() => null}>

                                            <li className="nav-item" title="Website List" onClick={() => history.push(`/websiteManagement/siteSetup/table`)}>
                                                <Link
                                                    className={`nav-link ${type === "table" && "active"}`}
                                                    id="pills-tab1"
                                                    data-toggle="pill"
                                                    to={`/websiteManagement/siteSetup/table`}
                                                    role="tab"
                                                    aria-controls="pills-tab11"
                                                    aria-selected="true"
                                                    >
                                                    <i className="fa fa-globe"></i>
                                                    Website List
                                                </Link>
                                            </li>
                                            </PermissionsGate>
                                            <PermissionsGate scopes={['wbssitebrandtmpview']} RenderError={() => null}>

                                            <li className="nav-item" title="Brand Templates" onClick={() => history.push(`/websiteManagement/siteSetup/brand_Templates`)}>
                                                <Link
                                                    className={`nav-link ${type === "brand_Templates" && "active"}`}
                                                    id="pills-tab2"
                                                    data-toggle="pill"
                                                    to={`/websiteManagement/siteSetup/brand_Templates`}
                                                    role="tab"
                                                    aria-controls="pills-tab12"
                                                    aria-selected="true"
                                                    >
                                                    <i class="fa-light fa-swatchbook"></i> Brand Templates
                                                </Link>
                                            </li>
                                            </PermissionsGate>
                                            <li className="nav-item" title="Audit trail" onClick={() => history.push(`/websiteManagement/siteSetup/auditTrail`)}>
                                                <Link
                                                    className={`nav-link ${type === "auditTrail" && "active"}`}
                                                    id="pills-tab2"
                                                    data-toggle="pill"
                                                    to={`/websiteManagement/siteSetup/auditTrail`}
                                                    role="tab"
                                                    aria-controls="pills-tab12"
                                                    aria-selected="true"
                                                >
                                                    <i className="fal fa-history"></i>Audit trail
                                                </Link>
                                            </li>
                                        </ul>
                                    )}
                                    <div className="tab-content" id="pills-tabContent">
                                        <div className="tab-pane fade active show" id="pills-tab11" role="tabpanel" aria-labelledby="pills-tab1">
                                            {type == "table" && <WebsiteList />}
                                            {type == "brand_Templates" && <BrandTemplates />}
                                            {type == "auditTrail" && <EventAuditTrail apiParams={''} apiFunction={getWebsiteAuditTrailList} apiFilter={getWebsiteAuditTrailListFilters} exportName={"Site setup audit trails"}/>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default WebsiteManagement;
